import axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ReactSelect from "../../../Components/PortalSelect";
import { AssignSalesExecutiveSchema } from "../../../ValidationSchema";
import { Autocomplete, TextField } from "@mui/material";
import Modal from "../../../Components/Modal";

const AssignSalesExecutiveAddForm = ({ show, userId, orderType, onClose }) => {
  const Navigate = useNavigate();
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [selectType, setSelectType] = useState("single"); // "single" | "multiple"
  const isSubAdmin = user?.user_type === "sub_admin";
  const labelText = isSubAdmin ? "Graphic Designer" : "Sales Executive";
  const placeholderText = isSubAdmin
    ? "Select Graphic Designer"
    : "Select Sales Executive";
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [totalpage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [buyerOptions, setBuyerOptions] = useState([]);

  const handlePageClick = (e) => {
    setPage(e.selected + 1);
  };

  const [salesExecutiveData, setSalesExecutiveData] = useState([]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      border: "1px solid #bfc9d4",
      boxShadow: "#000 !important",
      borderRadius: "6px",
      padding: "4px",
      "&:hover": {
        border: "1px solid #bfc9d4",
      },
    }),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#606060",
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      color: "#fff",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#000",
      "& > svg": {
        backgroundColor: "#fff",
        borderRadius: "10px",
        marginLeft: "2px",
        marginRight: "2px",
      },
      ":hover": {
        backgroundColor: data.color,
        color: data.color,
      },
    }),
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "white",
        color: "#000",
        ":hover": {
          backgroundColor: "#f5f5f5",
        },
      };
    },
  };

  const SalesExecutiveData = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/admin/sub-admin-sales-excutive`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`,
        },
      })
      .then((res) => {
        setSalesExecutiveData(
          res?.data?.data?.map((item) => {
            return {
              label: item?.name || "Untitled", // fallback if title is undefined
              value: item?.id,
            };
          })
        );
      })
      .catch((err) => {
        if (err.response.data.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const BuyerLeadData = () => {
    const searchQuery = search ? `&search=${search}` : "";

    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/buyer-lead?page=${page}${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        setTotalPage(res?.data?.data?.pages);
        setData(res?.data?.data?.desc);

        let leads = res?.data?.data?.desc || [];

        if (user?.user_type === "admin") {
          leads = leads.filter((item) => item?.user?.subAdminId === null);
        } else if (user?.user_type === "sub_admin") {
          leads = leads.filter(
            (item) => item?.user?.subAdminGraphicDesignerId === null
          );
        }

        // 🆕 Extract buyers for dropdown
        const buyers = leads.map((item) => ({
          label: item?.user?.name, // or item.buyer_name depending on API
          value: item?.user?.id,
        }));

        setBuyerOptions(buyers);
      })
      .catch((err) => {
        if (err?.response?.data?.message === "Unauthorized!") {
          Navigate("/");
        }
      });
  };

  const [initialValues] = useState({
    sales_executive_id: "",
    userId: [],
  });

  const AddSubCategory = useFormik({
    initialValues,
    validationSchema: AssignSalesExecutiveSchema,

    onSubmit: (values, action) => {
      let data = {
        userId: userId,
        sales_executive_id: values.sales_executive_id,
      };
      axios
        .post(`${process.env.REACT_APP_URL}/admin/assign-order-update`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`${res?.data?.message}`);
            // Navigate("/admin/supplier-by-lead/list", { state: res.data.msg });
            // window.location.reload();
            if (orderType === "Offline Buyer") {
              Navigate("/admin/supplier-by-lead/list", { state: res.data.msg });
              window.location.reload();
            } else {
              Navigate("/admin/buyer/list", { state: res.data.msg });
              window.location.reload();
            }
            onClose();
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  React.useEffect(() => {
    SalesExecutiveData();
    BuyerLeadData();
  }, [orderType]);


  return (
    <Modal
      open={!!show}
      onClose={onClose}
      title={isSubAdmin ? "Assign Graphic Designer" : "Assign Sales Executive"}
      subtitle="Choose who should take this order forward."
      size="sm"
      footer={
        <>
          <button type="button" className="al-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="al-btn al-btn--primary"
            onClick={AddSubCategory.handleSubmit}
          >
            Assign
          </button>
        </>
      }
    >
      <div className="al-field">
        <label className="al-label">{labelText}</label>
        <ReactSelect
          options={salesExecutiveData}
          isClearable={false}
          styles={colourStyles}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
          placeholder={placeholderText}
          name="sales_executive_id"
          onChange={(selectedOption) => {
            AddSubCategory.setFieldValue(
              "sales_executive_id",
              selectedOption ? selectedOption.value : ""
            );
          }}
          value={salesExecutiveData.find(
            (item) => item?.value === AddSubCategory?.values?.sales_executive_id
          )}
        />
        {AddSubCategory?.errors?.sales_executive_id &&
          AddSubCategory?.touched?.sales_executive_id && (
            <span className="al-err">
              {AddSubCategory?.errors?.sales_executive_id}
            </span>
          )}
      </div>
    </Modal>
  );
};

export default AssignSalesExecutiveAddForm;
